import { useMutation, useQueryClient } from '@tanstack/react-query'

import {
  TCampaign,
  TCampaignUpdatePayload,
  TCampaignError,
} from '~/features/campaigns/models'
import { queryKeys } from '~/features/campaigns/utils'
import { EHttpService, EServerPath } from '~/models/api'
import HttpService from '~/services/http'
import pathBuilder from '~/utils/api'

const updateCampaign = (id: string, payload: TCampaignUpdatePayload) => {
  return HttpService.put<TCampaign | TCampaignError>(
    {
      path: pathBuilder(EServerPath.campaign, { id }),
      payload,
    },
    EHttpService.campaigns,
  ).then((res) => {
    return res.data ? res.data : res
  })
}

const useUpdateCampaign = (id: string) => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (payload: TCampaignUpdatePayload) =>
      updateCampaign(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.campaign(id),
      })
    },
  })

  return {
    ...mutation,
  }
}

export default useUpdateCampaign
